const Const = {
    FIXED_REDUCED_PERCENTAGE_REDUCE_VALUE: 'FIXED_REDUCED_PERCENTAGE_REDUCE_VALUE',
    FIXED_REDUCED_PERCENTAGE_REDUCE_VALUE_UPDATE: 'FIXED_REDUCED_PERCENTAGE_REDUCE_VALUE_UPDATE',
    FIXED_REDUCED_PERCENTAGE_REDUCE_VALUE_CLEAR: 'FIXED_REDUCED_PERCENTAGE_REDUCE_VALUE_CLEAR',
    FIXED_REDUCED_PERCENTAGE_REDUCE_VALUE_SET_TO_DEFAULT: 'FIXED_REDUCED_PERCENTAGE_REDUCE_VALUE_SET_TO_DEFAULT',
};

export default Const;